'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'person-running';
var width = 448;
var height = 512;
var aliases = [127939,"running"];
var unicode = 'f70c';
var svgPathData = 'M256.5-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM123.2 160c-6.5 0-12.3 3.9-14.8 9.8L78.7 241.2c-5.1 12.2-19.1 18-31.4 12.9s-18-19.1-12.9-31.4l29.7-71.4C74 127.5 97.3 112 123.2 112l93.8 0c33.3 0 63.8 18.8 78.7 48.6l29.5 58.9c1.4 2.7 4.1 4.4 7.2 4.4l60.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-60.2 0c-21.2 0-40.6-12-50.1-31l-3.1-6.2-26.1 82.7 55.4 14.4c23.9 6.2 36.5 32.4 26.5 55L278.4 513.7c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l52.5-118.2-124.7-32.5c-30.6-8-48.5-39.7-39.6-70l30.7-104.3 2.7-9.2-33 0zm83.1 0c-.5 1.6-12.9 44-37.4 127.1-1.3 4.3 1.3 8.9 5.7 10l32 8.3 41.3-130.9c-7.5-9.1-18.8-14.5-30.8-14.5l-10.7 0zM117.6 375.1c9.7 6.6 20.6 11.7 32.6 14.9l11.9 3.1-5.2 14.6c-5.3 14.7-14.4 27.8-26.4 37.8l-90.7 76c-10.2 8.5-25.3 7.2-33.8-3s-7.2-25.3 3-33.8l90.7-76c5.5-4.6 9.6-10.5 12-17.2l5.9-16.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPersonRunning = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;